import React, { useState, useEffect } from "react";
import { useParams, useNavigate } from "react-router-dom";
import axios from "../api/api";
import "./ProductDetails.css";
import Layout from "../components/Layout";
import { Swiper, SwiperSlide } from "swiper/react";
import "swiper/css";
import "swiper/css/navigation";
import { Navigation, Pagination } from "swiper";

const ProductDetails = () => {
    const { productId } = useParams();
    const [product, setProduct] = useState(null);
    const [isLoggedIn, setIsLoggedIn] = useState(false);
    const navigate = useNavigate();

    useEffect(() => {
        // Kiểm tra trạng thái đăng nhập
        const token = localStorage.getItem('token');
        setIsLoggedIn(!!token);

        const fetchProduct = async () => {
            try {
                const response = await axios.get(`/products/${productId}`);
                setProduct(response.data);
            } catch (error) {
                console.error("Error fetching product details:", error);
            }
        };

        fetchProduct();
    }, [productId]);

    const handleAddToCart = async () => {
        try {
            await axios.post('/carts/add', {
                productId: product._id,
                quantity: 1,
                price: product.price,
            });
            alert("Sản phẩm đã được thêm vào giỏ hàng.");
        } catch (error) {
            console.error("Error adding to cart:", error);
        }
    };

    const handleCheckout = async () => {
        try {
            await handleAddToCart(); // Thêm sản phẩm vào giỏ hàng
            navigate('/checkout');  // Chuyển đến trang thanh toán
        } catch (error) {
            console.error("Error during checkout:", error);
        }
    };

    if (!product) return <p>Đang tải thông tin sản phẩm...</p>;

    return (
        <Layout>
            <div
                className="product-details-container"
                style={{ backgroundColor: 'white', minHeight: '100vh', padding: '20px' }}
            >
                <div className="product-details-header">
                    {/* Thumbnail bên trái */}
                    <div className="product-thumbnail">
                        <img
                            src={`${process.env.REACT_APP_API_BASE_URL}${product.urlProductThumbnail}`}
                            alt={product.name}
                        />
                    </div>
                    {/* Thông tin sản phẩm */}
                    <div className="product-info">
                        <h1>{product.name}</h1>
                        <p>Mã sản phẩm: {product.code}</p>
                        <p>Giá: {product.price.toLocaleString()} VND</p>
                        <p>Loại: {product.category}</p>
                        <div className="product-action-buttons">
                            {isLoggedIn ? (
                                <>
                                    <button className="btn btn-primary" onClick={handleAddToCart}>
                                        Đưa vào giỏ hàng
                                    </button>
                                    <button className="btn btn-success" onClick={handleCheckout}>
                                        Đặt hàng
                                    </button>
                                </>
                            ) : (
                                <button
                                    className="btn btn-warning"
                                    onClick={() => navigate('/login')}
                                >
                                    Đăng nhập để đặt hàng
                                </button>
                            )}
                        </div>
                        <p className="product-note">
                            Quý khách đặt số lượng lớn vui lòng liên hệ người phụ trách sản phẩm STEAM (<strong>0912 539 102</strong>) để được hỗ trợ tốt nhất và áp dụng chính sách chiết khấu mua nhiều.
                        </p>
                    </div>
                </div>

                {/* Mô tả sản phẩm */}
                <div className="product-description">
                    <h3>Mô tả sản phẩm</h3>
                    <div
                        className="product-description-content"
                        dangerouslySetInnerHTML={{ __html: product.description }}
                    ></div>
                </div>

                {/* Slideshow ảnh dạng slide */}
                {Array.isArray(product.images) && product.images.length > 0 && (
                    <div className="product-slideshow">
                        <h3>Hình ảnh chi tiết</h3>
                        <Swiper
                            modules={[Navigation, Pagination]}
                            navigation
                            pagination={{ clickable: true }}
                            spaceBetween={10}
                            slidesPerView={1}
                        >
                            {product.images.map((url, index) => (
                                <SwiperSlide key={index}>
                                    <img
                                        src={`${process.env.REACT_APP_API_BASE_URL}${url}`}
                                        alt={`${product.name} - ${index + 1}`}
                                        className="product-slide-image"
                                    />
                                </SwiperSlide>
                            ))}
                        </Swiper>
                    </div>
                )}
            </div>
        </Layout>
    );
};

export default ProductDetails;
